var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.7649f586fbeeab21d86f085eed38ef41.svg#poi--heNNn';
                    var viewUrl = 'sprites.7649f586fbeeab21d86f085eed38ef41.svg#view-poi--heNNn';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 17 22',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };